import Ts from "@/components/search/parser/Terminals"
import { Grammar, simplify } from "@/components/search/parser/Grammar"

class Parser {
  constructor() {
    this.choices = []
    this.q = []
    this.currentOr = null
    this.currentAnd = null
    this.currentF = null
    this.tokens = []
  }

  simplify() {
    this.choices = this.choices.flatMap(choice => simplify(choice))
  }

  tokenize(input) {
    this.tokens = []
    input = input.trim()
    while (input) {
      var consumed = 0
      for (const t in Ts) {
        if (Ts[t].type == "keyword") {
          if (input.startsWith(Ts[t].keyword)) {
            consumed = Ts[t].keyword.length
            break
          }
        }
        if (Ts[t].type == "value") {
          const match = Ts[t].extractor.exec(input)
          if (match) {
            consumed = match[0].length
            break
          }
        }
      }
      consumed = consumed || input.indexOf(" ")
      if (consumed == -1) {
        this.tokens.push(input)
        input = ""
      } else {
        this.tokens.push(input.slice(0, consumed))
        input = input.slice(consumed).trim()
      }
    }
  }

  initChoices() {
    this.choices = [Grammar.S]
    this.simplify()
  }

  initQ() {
    this.currentF = null
    this.currentAnd = null
    this.currentOr = null
    this.q = []
  }

  insertNewOr() {
    this.currentF = null
    this.currentAnd = null
    this.currentOr = []
    this.q.push(this.currentOr)
  }

  insertNewAnd() {
    if (this.currentOr == null) this.insertNewOr()
    this.currentF = null
    this.currentAnd = []
    this.currentOr.push(this.currentAnd)
  }

  insertNewF() {
    if (this.currentAnd == null) this.insertNewAnd()
    this.currentF = {}
    this.currentAnd.push(this.currentF)
  }

  insertValue(field, value) {
    if (this.currentF == null) this.insertNewF()
    this.currentF[field] = value
  }

  apply(token) {
    this.choices = this.choices.filter(choice => {
      if (choice.length === 0) return false
      if (choice[0].type == "value") {
        if (choice[0].matcher.test(token)) {
          this.currentF[choice[0].field] = token
          return true
        }
        return false
      }
      if (choice[0].type == "keyword") {
        if (choice[0].keyword !== token) return false
        switch (choice[0].action) {
          case "INIT QUERY":
            this.initQ()
            break;
          case "INIT THAT ARE":
            this.insertNewOr()
            break;
          case "INIT OR":
            this.insertNewAnd()
            break;
          case "INIT AND":
            this.insertNewF()
            break;
          case "SET":
            this.insertValue(choice[0].field, choice[0].value)
            break;
        }
        return true
      }
      throw new Error("what")
    }).map(choice => choice.slice(1))
    this.simplify()
  }

  parse(input) {
    // If not using advanced search simply return the default suggestions
    if (!input.trim().startsWith(Ts.show_films.keyword)) {
      return {
        complete: "",
        correct: "",
        rest: input,
        queryType: "text",
        suggestions: (Ts.show_films.keyword.startsWith(input.trim()) ? [{
          type: "keyword",
          prompt: Ts.show_films.keyword,
          message: Ts.show_films.message,
        }] : []).concat([{
          type: "value",
          name: "TextSearch",
          prompt: "[Type Any Text]",
          message: "Textual search based on titles, persons, or imdbID",
        }]),
      }
    }

    this.initChoices()
    var query
    var lq
    var correct = 0
    var complete = 0
    var suggestions = this.suggestions()
    this.tokenize(input)
    for (var i = 0; i < this.tokens.length; i++) {
      this.apply(this.tokens[i])
      if (this.choices.length > 0) {
        correct = i+1
        suggestions = this.suggestions()
        if (this.choices.findIndex(choice => choice.length == 0) != -1) {
          complete = i+1
          query = JSON.stringify(this.q)
        }
      }
    }
    const rest = this.tokens.slice(correct).join(" ")
    if (rest) {
      suggestions = suggestions.filter(s => {
        if (s.type == "value") return s.prefixer.test(rest)
        if (s.type == "keyword") return s.keyword.startsWith(rest)
        return false
      })
    }
    suggestions = suggestions.map(s => {
      if (s.type == "value") {
        return {
          type: "value",
          name: s.name,
          prompt: s.prompt,
          message: s.message,
          uiAction: s.uiAction,
          uiIcon: s.uiIcon,
          priority: s.priority,
        }
      }
      if (s.type == "keyword") {
        return {
          type: "keyword",
          prompt: s.keyword,
          message: s.message,
          priority: s.priority,
        }
      }
      return {}
    })
    if (!suggestions.length) {
      suggestions.push({
        type: "clear",
        uiAction: "CLEAR",
        uiIcon: "mdi-backspace",
        priority: 9,
      })
    }
    if (suggestions.find(s => s.type == "keyword" && s.prompt == "that are")) {
      suggestions.push({
        type: "gui",
        name: "Filter",
        prompt: "[Insert Filter]",
        message: "Use this option to help add a filter",
        uiAction: "PICKER",
        uiIcon: "mdi-filter",
        priority: 9,
      })
    }
    suggestions.sort((s1, s2) => (s2.priority || 0) - (s1.priority || 0))
    return {
      complete: this.tokens.slice(0, complete).join(" "),
      correct: this.tokens.slice(complete, correct).join(" "), 
      rest: rest || " ",
      query: query,
      suggestions: suggestions
    }
  }

  suggestions() {
    return this.choices
        .filter(choice => choice.length > 0)
        .map(choice => choice[0])
  }
}

export default Parser
